import { all } from 'redux-saga/effects'

import { draftTradesRootSaga } from '../state/draft-trades-slice'

export function* rootSaga() {
  yield all([draftTradesRootSaga()])
}
